/**
 * Hands an imported draft from the import page to the editor.
 *
 * The draft carries File objects for its pictures; they stay in memory here
 * instead of going through the router's history state, which the browser
 * would try to serialise. The editor takes the draft exactly once.
 */
const drafts = new Map();
let counter = 0;

/** Stores a draft ({ title, summary, text, files: [{ placeholder, file, type }] }). */
export function putImportDraft(draft) {
  counter += 1;
  const id = `import-${Date.now()}-${counter}`;
  drafts.set(id, draft);
  return id;
}

/** Returns the draft for this id and forgets it; null when there is none. */
export function takeImportDraft(id) {
  if (!id || !drafts.has(id)) {
    return null;
  }

  const draft = drafts.get(id);
  drafts.delete(id);
  return draft;
}

/**
 * The draft's text with each media placeholder replaced by the blob URL
 * `stage` (usePendingMedia) returns for its file, so the files upload with
 * the article like ones the author inserted by hand.
 *
 * They are staged as 'pdf-import': a drawing an importer made out of a page's
 * vector graphics is an SVG, which the ordinary upload refuses, and that
 * source is what sends it to the route that checks it instead
 * (usePendingMedia, POST /uploads/import-svg).
 */
export function stageDraftText(draft, stage) {
  let text = draft.text;

  for (const { placeholder, file, type } of draft.files) {
    text = text.split(placeholder).join(stage(file, type, 'pdf-import'));
  }

  return text;
}
